import { renderIcon } from '../../SvgIcon.esm.js';

/******************************************************
 * This file was created by scripts/generate.js as part
 * of the build process. Do not edit this file directly.
 ******************************************************/
var iconType = {
  viewBox: "0 0 24 24",
  paths: [{
    d: "M3.14 10.86C2.2 6.22 6.21 2.2 10.86 3.13c2.28.46 4.17 2.21 4.85 4.44.65 2.16.15 4.19-.98 5.74l5.56 5.57c.39.39.39 1.02 0 1.41l-.094.083a.9959.9959 0 01-1.316-.083l-5.56-5.56c-1.55 1.13-3.58 1.63-5.74.98-2.23-.67-3.98-2.56-4.44-4.85zM9.5 5C7.01 5 5 7.01 5 9.5S7.01 14 9.5 14 14 11.99 14 9.5 11.99 5 9.5 5zm0 1l.79 2.44h2.46l-2.01 1.59.77 2.47-2.01-1.53-2.01 1.53.77-2.47-2.01-1.59h2.46z"
  }],
  circles: []
};
var SavedSearchIcon = function SavedSearchIcon(props) {
  return renderIcon(props, iconType);
};
export { SavedSearchIcon };